import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Global";
import uploadFile from "../../../images/uploadFile.jpg";
import axios from "axios";
import { useSelector } from "react-redux";

const RestrictedItemManage = () => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [restrictedItemName, setRestrictedItemName] = useState("");
  const [restrictedItemIcon, setRestrictedItemIcon] = useState("");
  const [restrictedItemImage, setRestrictedItemImage] = useState("");
  const [isPublished, setIsPublished] = useState(true);
  const { userToken, userId } = useSelector((state) => state.credential);

  const { id, restrictedItemId } = useParams();
  const navigate = useNavigate();

  const validForm =
    restrictedItemName.trim() !== "" && restrictedItemIcon.trim() !== "";
  const Submit = async (e) => {
    e.preventDefault();
    if (!validForm) {
      toast.error("Fill all the  fields");
    } else {
      if (parseInt(restrictedItemId) === 0) {
        try {
          const response = await fetch(
            Global.API_URL + "RoomNotAllowedItem/AddRoomNotAllowedItems",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
                AuthorizationUser: userToken,
              },
              body: JSON.stringify({
                itemName: restrictedItemName,
                itemIcon: restrictedItemIcon,
                itemImage: restrictedItemImage,
                isPublished: isPublished,
              }),
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              toast.success(result.message);
              navigate("/room-restricted-item");
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
        }
      } else {
        try {
          const response = await fetch(
            Global.API_URL +
              "RoomNotAllowedItem/EditNotAllowedItem?itemid=" +
              restrictedItemId,
            {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
                AuthorizationUser: userToken,
              },
              body: JSON.stringify({
                itemName: restrictedItemName,
                itemIcon: restrictedItemIcon,
                itemImage: restrictedItemImage,
                isPublished: isPublished,
              }),
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              toast.success(result.message);
              navigate("/room-restricted-item");
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
        }
      }
    }
    setDisableSubmit(false);
  };

  const handleIcon = async (e) => {
    const formData = new FormData();
    formData.append("Images", e.target.files[0]);
    formData.append("Sender", "A");
    formData.append("SenderID", userId);

    try {
      const response = await axios.post(
        Global.API_URL + "Others/UploadSingleImage",
        formData,
        {
          headers: {
            "bs-api-key": Global.bs_api_key,
            AuthorizationUser: userToken,
          },
        }
      );
      setRestrictedItemIcon(response.data[0]);
    } catch (ex) {
      console.log(ex);
    }
  };

  const handleImage = async (e) => {
    const formData = new FormData();
    formData.append("Images", e.target.files[0]);
    formData.append("Sender", "A");
    formData.append("SenderID", userId);

    try {
      const response = await axios.post(
        Global.API_URL + "Others/UploadSingleImage",
        formData,
        {
          headers: {
            "bs-api-key": Global.bs_api_key,
            AuthorizationUser: userToken,
          },
        }
      );
      setRestrictedItemImage(response.data[0]);
    } catch (ex) {
      console.log(ex);
    }
  };

  useEffect(() => {
    if (parseInt(restrictedItemId) !== 0) {
      const GetRestrictedItem = async () => {
        try {
          const response = await fetch(
            Global.API_URL +
              "RoomNotAllowedItem/GetRoomNotAllowedItemById?roomitemid=" +
              restrictedItemId,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "bs-api-key": Global.bs_api_key,
              },
            }
          );
          if (response.ok) {
            const result = await response.json();
            if (result.code === 0) {
              setRestrictedItemName(result.message.itemName);
              setRestrictedItemIcon(result.message.itemIcon);
              setRestrictedItemImage(result.message.itemImage);
              setIsPublished(result.message.isPublished);
            } else {
              toast.error(result.message);
            }
          } else {
            const result = await response.json();
            toast.error(result.message);
            navigate("/room-restricted-item");
          }
        } catch (error) {
          toast.error(error.Message || "Something went wrong");
          navigate("/room-restricted-item");
        }
      };

      GetRestrictedItem();
    }
  }, [restrictedItemId, navigate, id]);

  return (
    <Fragment>
      <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
        <div className="card-action coin-tabs mb-2"></div>
        <div className="d-flex align-items-center mb-2">
          <button
            type="submit"
            className="btn btn-primary margin-right-15"
            onClick={(e) => Submit(e)}
            disabled={disableSubmit}
          >
            Submit
          </button>
          <Link to={"/room-restricted-item"} className="btn btn-secondary">
            Back
          </Link>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Item Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Item Name"
                    value={restrictedItemName}
                    onChange={(e) => setRestrictedItemName(e.target.value)}
                  />
                </div>
                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <div className="form-check form-check-inline mt-6">
                    <label className="form-check-label">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value={isPublished}
                        checked={isPublished}
                        onChange={(e) =>
                          setIsPublished(
                            e.target.value === "true" ? false : true
                          )
                        }
                      />
                      Published
                    </label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Restricted Item Image <span className="text-danger">*</span>
                  </label>
                  <br />
                  <label htmlFor="restrictedItemImage">
                    <img
                      src={
                        restrictedItemImage && restrictedItemImage !== ""
                          ? Global.PHOTO_URL + restrictedItemImage
                          : uploadFile
                      }
                      width="250"
                      alt="restrictedItemImage"
                    />
                  </label>
                  <input
                    type="file"
                    name="restrictedItemImage"
                    id="restrictedItemImage"
                    onChange={handleImage}
                    style={{ visibility: "hidden" }}
                  ></input>
                </div>

                <div className="form-group mb-5 col-md-6 col-lg-6 ">
                  <label>
                    Restricted Item Icon <span className="text-danger">*</span>
                  </label>
                  <br />
                  <label htmlFor="restrictedItemIcon">
                    <img
                      src={
                        restrictedItemIcon === ""
                          ? uploadFile
                          : Global.PHOTO_URL + restrictedItemIcon
                      }
                      width="250"
                      alt="restrictedItemIcon"
                    />
                  </label>
                  <input
                    type="file"
                    name="restrictedItemIcon"
                    id="restrictedItemIcon"
                    onChange={handleIcon}
                    style={{ visibility: "hidden" }}
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RestrictedItemManage;
